import { createReducer, on } from '@ngrx/store'
import {
  login,
  loginSuccess,
  loginFailure,
  logout,
  logoutSuccess,
} from './authentication.actions'
import type { User } from './auth.model'

export type AuthenticationState = {
  isLoggedIn: boolean
  user: User | null
  error: string | null
}

const initialState: AuthenticationState = {
  isLoggedIn: false,
  user: null,
  error: null,
}

export const authenticationReducer = createReducer(
  initialState,
  on(login, (state) => ({ ...state, error: null })),
  on(loginSuccess, (state, { user }) => ({
    ...state,
    isLoggedIn: true,
    user,
    error: null,
  })),
  on(loginFailure, (state, { error }) => ({ ...state, error })),
  on(logout, (state) => ({ ...state, isLoggedIn: false, user: null })),
  on(logoutSuccess, (state) => ({ ...state, isLoggedIn: false, user: null }))
)